import GradeMaster from '../../features/masters/GradeMaster'

const GradePage = () => {
  return <GradeMaster />
}

export default GradePage